module.exports = __webpack_public_path__ + "static/img/advantage1.b111c038.png";